export default __webpack_public_path__ + "static/media/fishmarket2_03.fb75f281.png";